<template>
  <div class="layout_up" :style="{ background: bgColor || backgroundColorChange }">
    <div class="navCon flex_between cursor w_1280">
      <div class="navbar_logo cursor" @click="goPage('/')">
        <img src="@/assets/images/logo.png" alt="">
      </div>
      <div class="navbar_box flex_center flex_column" v-for="item in navbarList" :key="item.index"
        @click="switchNavigation(item)">
        <div :class="navigationIndex == item.index ? 'navbar_box_select' : ''">{{ item.name }}</div>
        <div :class="navigationIndex == item.index ? 'navbar_line_select' : 'navbar_line'"></div>
      </div>
      <div class="navbar_box flex_center flex_column">
        <el-dropdown class="custom-dropdown" @command="handleCommand">
          <span class="el-dropdown-link">
            政府服务
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :command="item.value" v-for="item in serviceList" :key="item.code">{{ item.name
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div class="navbar_line"></div>
      </div>
      <div class="user_icon color_fff" v-if="isLogin == true">
        <el-icon>
          <User />
        </el-icon>
      </div>

      <div class="top_box flex_center color_fff" @click="goPage('/loginPage')" v-if="isLogin == false">
        登录/注册
      </div>

      <!-- <div class="user_icon color_fff" @click="goPage('/authenticationManagement')" v-else>
        {{ userName }}
      </div> -->
    </div>

    <!-- <div class="about_us_box flex_center cursor" @click="goPage('/aboutUs')">
      关于我们
    </div> -->

    <el-backtop :right="50" :bottom="100" />
  </div>
</template>

<script>
import { userInfo, systemInfo } from "@/utils/api";
export default {
  name: 'navbar',
  props: {
    navigationIndex: String,
    bgColor: String
  },
  components: {
  },
  data() {
    return {
      isLogin: false,
      navbarList: [
        {
          name: '首页',
          index: 0,
          url: '/',
          type: 0,
        },
        {
          name: '产业图谱',
          index: 1,
          url: '/industryMap',
          type: 1,
        },
        {
          name: '云端产业园',
          index: 2,
          url: '/industrialPark',
          type: 1,
        },
        {
          name: '产业新闻',
          index: 3,
          url: '/newsInformationPage',
          type: 0,
        },
        {
          name: '产业运行',
          index: 4,
          url: '/industrialOperation',
          type: 1,
        },
        {
          name: '产业协同',
          index: 5,
          url: '/',
          type: 0,
        },
        // {
        //   name: '政府服务',
        //   index: 6,
        //   url: ''
        // }
      ],
      userName: localStorage.getItem('userName'),
      backgroundColorChange: null,
      systemLink: [],
      serviceList: [],
      // navigationIndex: 0
    };
  },
  mounted() {
    if (this.$route.query.token) {
      let token = this.$route.query.token;
      localStorage.token = token;
    }
    this.getUserInfo();
    window.addEventListener('scroll', this.handleScroll);
    this.getSystemInfo();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async getSystemInfo() {
      let res = await systemInfo();
      if (res.code == 200) {
        this.systemLink = res.data.link;
        this.serviceList = res.data.serviceList;
      }
    },

    handleCommand(command) {
      if (command != null) {
        window.open(command, '_blank');
      } else {

      }
    },
    handleScroll() {
      const scrollTop = window.scrollY;
      if (scrollTop === 0) {
        this.backgroundColorChange = null;
      } else {
        this.backgroundColorChange = '#0E1C42';
      }
    },
    getUserInfo() {
      userInfo().then((res) => {
        if (res.code == 200) {
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }
      });
    },
    switchNavigation(item) {
      if (item.index == 5) {
        window.open(this.systemLink[0].value + '?token=' + localStorage.token, '_blank');
        return
      }
      // this.navigationIndex = item.index;
      if (item.type == 0) {
        this.$router.push({
          path: item.url
        });
      } else {
        // 使用 router.resolve 获取路由的完整路径
        const route = this.$router.resolve({ path: item.url });
        window.open(route.href, '_blank');
      }
    },
    goPage(path, type) {
      this.$router.push({
        path: path
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.layout_up {
  position: fixed;
  z-index: 99;
  top: 0;
  width: 100%;
  height: 129px;
  background: linear-gradient(180deg, #0E1C42 0%, rgba(14, 27, 65, 0) 100%);
}

.user_icon {
  margin-left: 20px;
  font-size: 20px;
  line-height: 20px;
}

.top_box {
  width: 125px;
  height: 43px;
  background: #238AFE;
  border-radius: 6px;
  margin-left: 20px;
  font-size: 16px;
  color: #FFFFFF;
}

.navCon {
  height: 100%;
}

.navbar_logo {
  width: 375px;
  margin-right: 60px;

  img {
    width: 367px;
    height: auto;
  }
}

.navbar_box {
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
}

.navbar_box_select {
  color: #238AFE;
}

.navbar_line {
  height: 3px;
  width: 100%;
  border-radius: 2px;
  margin-top: 5px;
}

.navbar_line_select {
  height: 3px;
  width: 100%;
  background-color: #238AFE;
  border-radius: 2px;
  margin-top: 5px;
}

.el-dropdown-link {
  cursor: pointer;
  outline: none;
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

/* 覆盖下拉框的背景颜色 */
.el-dropdown-menu {
  background-color: #284187;
  border: none;
}

// 嵌套修改下拉菜单项样式
:deep .el-dropdown-menu__item {
  color: #CECECE;
  font-size: 16px;

  &:hover {
    background-color: #238AFE;
    color: #ffffff;
  }
}

.about_us_box {
  position: fixed;
  width: 10px;
  height: 130px;
  background-color: #00AC64;
  border-radius: 20px;
  bottom: 150px;
  right: 20px;
  color: #fff;
  font-size: 18px;
  padding: 0 15px;
}
</style>